import { Component, ElementRef, Renderer2} from '@angular/core';
import { BasePaneComponent } from 'sharedFeatures/base-pane';
import { BillingDetailsBodyComponent } from './billing-details-body.component';

@Component({
    selector: 'billing-details-pane',
    templateUrl: '../../base-pane/base-pane.component.html',
    styleUrls: ['../../base-pane/base-pane.component.less']
})
export class BillingDetailsPaneComponent extends BasePaneComponent {

    title = $localize`billing_details`;
    borderTopRadius = 0;
    width = 600;
    height = 610;

    constructor(el: ElementRef, renderer: Renderer2) {
        super(el, renderer);
        this.contentComponent = BillingDetailsBodyComponent;
    }
}